export default function mottaContatoIba() {
  const contatoIbaFormSubmit = document.querySelector("#form-submit-iba");

  contatoIbaFormSubmit &&
    contatoIbaFormSubmit.addEventListener("submit", function (event) {
      event.preventDefault();
      disabledBtn();

      const formData = new FormData();
      formData.append(
        "nome",
        document.querySelector("#form-submit-iba input[name=nome]").value
      );
      formData.append(
        "empresa",
        document.querySelector("#form-submit-iba input[name=empresa]").value
      );
      formData.append(
        "email",
        document.querySelector("#form-submit-iba input[name=email]").value
      );
      formData.append(
        "data",
        document.querySelector("#form-submit-iba select[name=data]")
          .selectedOptions[0].text
      );
      formData.append(
        "horario",
        document.querySelector("#form-submit-iba select[name=horario]")
          .selectedOptions[0].text
      );

      const url = "/contato-iba/";
      axios
        .post(url, formData)
        .then((response) => showMessage(response))
        .catch((response) => showMessage(response));
    });

  function showMessage(response) {
    const message = response.data ? response.data.message : response.message;
    GLOBAL.showToastify(message);
    contatoIbaFormSubmit.reset();
    setTimeout(enabledBtn, 1000);
  }

  const btnSubmit = document.querySelector("#form-submit-iba .btn");

  function disabledBtn() {
    btnSubmit.disabled = true;
    btnSubmit.style.opacity = "0.5";
  }

  function enabledBtn() {
    btnSubmit.disabled = false;
    btnSubmit.style.opacity = "1.0";
  }
}
